// @flow
import React from 'react';
import _ from 'lodash/fp';
import type {ErrorDto} from '../../dtos';
const mapWithIndex = _.map.convert({cap: false});
const flatMapWithIndex = _.flatMap.convert({cap: false});

export type ErrorItemsProps = {
  errors: string[],
  startIndex?: number,
};

const ErrorItems = ({
  errors,
  startIndex = 0,
}: ErrorItemsProps) =>
  mapWithIndex((m, i) => (
    <li key={startIndex + i}>{m}</li>
  ), errors);

export type Props = {
  error: ?ErrorDto,
};

const ServerError = ({error}: Props) => (
  <div className="ServerError">
    {error &&
      <div className="callout alert">
        <h5>{error.message}</h5>
        {!!error.errors && !_.isEmpty(error.errors) &&
          <ul>
            {Array.isArray(error.errors)
              ? (
                <ErrorItems errors={error.errors} />
              )
              : flatMapWithIndex((e, i) => (
                <ErrorItems
                  key={i}
                  errors={e}
                  startIndex={i} />
              ), _.values(error.errors))
            }
          </ul>
        }
      </div>
    }
  </div>
);

export default ServerError;



// WEBPACK FOOTER //
// ./src/components/ServerError/ServerError.js